import { EnvironmentFilled, MailOutlined, HeartOutlined, SendOutlined, HeartFilled } from '@ant-design/icons';
import { Image, Button, Input }                                                      from 'antd';
import axios                                                                         from "axios";
import L                                                                             from 'leaflet';
import React, { useEffect, useState }                                                from 'react';
import { MapContainer, WMSTileLayer, Marker, Popup, useMap, Circle }                         from 'react-leaflet';
import { useLocation, useNavigate }                                                  from "react-router-dom";
import "../AllHome/AllHome.scss";
import "./Search.scss";
import {
  addToFavApi,
  removeFavApi
}                                                                                    from '../../reuseableComponents/CardComponent/apis/apis';
import ContainerCard
                                                                                     from '../../reuseableComponents/CardComponent/ContainerCard/ContainerCard';
import FormTable                                                                     from '../../reuseableComponents/Form/Form';
import Loader                                                                        from '../../reuseableComponents/Loader/Loader';
import Notification
                                                                                     from '../../reuseableComponents/Notification';
import { createConversation }                                                        from '../conversation/apis/apis';
import { getRecommendedPropertiesApi }                                               from '../landingPage/apis/apis';
import { filterProperties }                                                          from "./apis/apis";


delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const MapMover = (props) => {
  const map = useMap();
  map.setView(props.position, 13);
  return null;
};
const locations = [
  { label: "Distrito Nacional", value: "Distrito Nacional" },
  { label: "Santo Domingo Este", value: "Santo Domingo Este" },
  { label: "Santo Domingo Norte", value: "Santo Domingo Norte" },
  { label: "Santo Domingo Oeste", value: "Santo Domingo Oeste" },
  { label: "Santiago", value: "Santiago" },
  { label: "Punta Cana", value: "Punta Cana" },
  { label: "San Cristóbal", value: "San Cristóbal" },
  { label: "La Vega", value: "La Vega" },
  { label: "Puerto Plata", value: "Puerto Plata" },
  { label: "San Pedro de Macorís", value: "San Pedro de Macorís" },
  { label: "Azua", value: "Azua" },
  { label: "Bahoruco", value: "Bahoruco" },
  { label: "Barahona", value: "Barahona" },
  { label: "Dajabón", value: "Dajabón" },
  { label: "Duarte", value: "Duarte" },
  { label: "El Seibo", value: "El Seibo" },
  { label: "Elías Piña", value: "Elías Piña" },
  { label: "Espaillat", value: "Espaillat" },
  { label: "Hato Mayor", value: "Hato Mayor" },
  { label: "Hermanas Mirabal", value: "Hermanas Mirabal" },
  { label: "Independencia", value: "Independencia" },
  { label: "La Altagracia", value: "La Altagracia" },
  { label: "La Romana", value: "La Romana" },
  { label: "María Trinidad Sánchez", value: "María Trinidad Sánchez" },
  { label: "Monseñor Nouel", value: "Monseñor Nouel" },
  { label: "Monte Plata", value: "Monte Plata" },
  { label: "Montecristi", value: "Montecristi" },
  { label: "Pedernales", value: "Pedernales" },
  { label: "Peravia", value: "Peravia" },
  { label: "Samaná", value: "Samaná" },
  { label: "San José de Ocoa", value: "San José de Ocoa" },
  { label: "San Juan", value: "San Juan" },
  { label: "Sánchez Ramírez", value: "Sánchez Ramírez" },
  { label: "Santiago Rodríguez", value: "Santiago Rodríguez" },
  { label: "Valverde", value: "Valverde" }
];

let formData = [
  {
    label: "Purpose",
    value: "isForSale",
    type: "select",
    options: [
      {
        label: "All",
        value: null
      },
      {
        label: "Sale",
        value: true
      },
      {
        label: "Rent",
        value: false
      }
    ]
  },
  {
    label: "City",
    value: "city",
    type: "select",
    options: locations
  },
  {
    label: "Property type",
    value: "type",
    type: "select",
    options: [
      {
        label: "All",
        value: null
      },
      {
        label: "Home",
        value: "Home"
      },
      {
        label: "Apartment",
        value: 'Apartment'
      },
      {
        label: "Flat",
        value: 'Flat'
      }
    ]
  }
]

const SearchScreen = () => {
  const [state, setState] = useState({
    loader: false,
    searchLoader:false,
    currCity: null,
    searchedData: {},
    centerMap: [39, 77],
    oldValues:null,
    searchInput:""
  })
  const navigate = useNavigate()
  // const [mapPosition, setMapPosition] = useState(position);


  const location = useLocation();
  let { searchQuery } = location?.state || {};
  const [filteredData, setFilteredData] = useState([])
  const handleSearch = async () => {
    setState({
      ...state,
      loader: true,
      currCity: searchQuery,
      searchInput: searchQuery
    })

    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${ searchQuery }`
      );
      let location
      if (response.data.length > 0) {
        location = response.data[0];
        const newLatLng = [parseFloat(location.lat), parseFloat(location.lon)];
        setState(prevState => ({
          ...prevState,
          centerMap: newLatLng,
          searchInput: searchQuery
        }))
        // setMapPosition(newLatLng);
      }
      else {
        alert('Location not found');
      }
      let result = await getRecommendedPropertiesApi({ longitude: parseFloat(location.lon), latitude: parseFloat(location.lat) })
      if (result?.data) {
        setState(prevState => ({
          ...prevState,
          loader: false,
          searchInput: searchQuery
        }))
        setFilteredData(result?.data?.data)
      }
      else {
        setState(prevState => ({
          ...prevState,
          loader: false,
          searchInput: searchQuery
        }))
      }
    }
    catch (error) {
      console.error('Error fetching location:', error);
      setState(prevState => ({
        ...prevState,
        loader: false
      }))
    }
  };

  const filter = async (values) => {
    let data = values

    if (values.isForSale === null) {
      delete data["isForSale"]
      delete data["isForRent"]
    }

    if (!!searchQuery && !values?.city) {
      data = {
        ...data,
        city: searchQuery
      }
    }

    values.type === null && delete data["type"]

    setState({
      ...state,
      loader: true,
      currCity: values?.city ? values?.city : searchQuery,
      searchedData: values,
      oldValues: values
    })

    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${ values?.city ? values?.city : searchQuery }`
      );

      if (response?.data?.length > 0 && (!!values?.city || !!searchQuery)) {
        const location = response.data[0];
        const newLatLng = [parseFloat(location.lat), parseFloat(location.lon)];
        setState(prevState => ({
          ...prevState,
          centerMap: newLatLng,
          searchInput: ""
        }))
      }
      else {
        alert('Location not found');
      }

      let result = await filterProperties(data)
      if (result?.data) {
        setState(prevState => ({
          ...prevState,
          loader: false,
          searchInput: ""
        }))
        setFilteredData(result?.data)
      }
      else {
        setState(prevState => ({
          ...prevState,
          loader: false,
          searchInput: ""
        }))
      }
    }
    catch (error) {
      console.error('Error fetching location:', error);
    }
  }
  let isLoggedIn = localStorage.getItem("token") && localStorage.getItem("userLogin");
  let userId = localStorage.getItem("userId")

  const saveProperty = async (id) => {
    try {
      let result = await addToFavApi({ propertyId: id })
      if (result?.status) {
        Notification("success", "Property has been saved");
        !!state.oldValues ? filter(state.oldValues) : handleSearch()
      }
      else {
        Notification('error', "Cannot save this property", "Error.");
      }
    }
    catch (err) {
      Notification('error', "Cannot save this property", "Error.");
    }
  };

  const removeSaveProperty = async (id) => {
    try {
      let result = await removeFavApi(id)
      if (result?.status) {
        Notification("success", "Property has been removed from save");
        !!state.oldValues ? filter(state.oldValues) : handleSearch()
      }
      else {
        Notification('error', "Cannot remove this property from saved", "");
      }
    }
    catch (err) {
      Notification('error', "Cannot remove this property from saved", ".");
    }
  };

  const createCustomIcon = (price) =>
    L.divIcon({
      className: 'custom-marker-wrapper',
      html: `
      <div class="custom-marker" style="display: flex; flex-direction: column; gap: 6px; align-items: center ">
        <img src="https://cdn-icons-png.flaticon.com/512/684/684908.png" class="marker-icon"  style="width: 20px"/>
        <div style="padding: 6px; background: white; border-radius: 12px; display: flex" class="marker-btn">$${price}</div>
      </div>
    `,
      iconSize: [50, 60],
      iconAnchor: [25, 60], // makes it anchor from bottom center
    });

  const getSearchData = async () => {
    setState(prevState => ({
      ...prevState,
      loader: true,
      searchLoader: state.searchInput && true
    }))
    let response
    try {
      if(state.searchInput){
        response = await axios.get(
          `https://nominatim.openstreetmap.org/search?format=json&q=${state.searchInput }`
        );

        if (response?.data?.length > 0) {
          const location = response.data[0];
          const newLatLng = [parseFloat(location.lat), parseFloat(location.lon)];
          let responseProp = await getRecommendedPropertiesApi({ longitude: parseFloat(location.lon), latitude: parseFloat(location.lat) })
          setFilteredData(responseProp?.data?.data)
          setState(prevState => ({
            ...prevState,
            centerMap: newLatLng,
            loader: false,
            searchLoader: false,
            currCity:state.searchInput
          }))
        }
        else {
          alert('Location not found');
          setState(prevState => ({
            ...prevState,
            loader: false,
            searchLoader: false
          }))
        }

      } else {
        Notification("success", "Enter location first","")
        setState(prevState => ({
          ...prevState,
          loader: false,
          searchLoader: false
        }))
      }
    } catch (e) {
      setState(prevState => ({
        ...prevState,
        loader: false,
        searchLoader: false
      }))
    }
  }

  useEffect(() => {
    handleSearch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <div className={ "all-container" } style={ {
    padding: "2%",
    paddingTop: "4%"
  } }>
    <div className={ "allHomeContainer searchPropertyScreen" }>
      <div className={ "searchLeftSection" } style={ {
        width: window.innerWidth > 790 ? "18%" : "100%"
      } }>
        <h4 style={ {
          marginBottom: 10,
          marginTop: 20
        } }>Filters</h4>
        { !state.searchLoader && <FormTable data={ formData }
                     customStyle={
                       {
                         display: "grid",
                         gridTemplateColumns: "100%",
                         justifyContent: "space-between",
                         width: "100%",
                         marginTop: "4%"
                       } }
                     buttonLabel={ "Search" }
                     saveFunc={ filter }
                     mainWidth={ "100%" }/> }
      </div>
      <div className={ "right" }>
        <div style={{
          display:"flex",
          gap:10,
          alignItems:"center",
          width:"80%",
          margin:"auto",
          marginTop:40,
          marginBottom:20
        }}>
          <Input value={state.searchInput} placeholder={"Search location"} onChange={(e)=>setState({
            ...state,
            searchInput: e.target.value
          })}/>
          <Button onClick={getSearchData} type={"primary"}>Search</Button>
        </div>
        <MapContainer className={ "mapContainer" } center={ state.centerMap } zoom={ 13 } scrollWheelZoom={ true }>
          <WMSTileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {/*<Circle*/}
          {/*  center={state.centerMap}*/}
          {/*  radius={1000} // Radius in meters (10km = 10000m)*/}
          {/*  pathOptions={{ color: "blue", fillColor: "blue", fillOpacity: 0.3 }}*/}
          {/*/>*/}

          {
             !state.loader && filteredData.length > 0 && filteredData.map(item => (item?.latitude && item?.longitude) &&
              <Marker position={ [item.latitude, item.longitude] } icon={createCustomIcon(item?.price)}>
                <Popup closable={false}>
                  <div>
                    <div style={ {
                      display: "flex",
                      gap: 6
                    } }>
                      <Image src={ item?.photos[0] } style={ {
                        height: 60,
                        width: 60,
                        borderRadius: 10
                      } }/>
                      <div>
                        <p style={ {
                          margin: 0
                        } }><EnvironmentFilled style={ {
                          color: "#1677ff"
                        } }/> { item.city }</p>
                        <p style={ {
                          margin: 0,
                          marginTop: 6,
                          fontSize: 16,
                          fontWeight: 550,
                          color: "black"
                        } }>{ item?.title }</p>
                        <p style={ {
                          margin: 0,
                          marginTop: 4,
                          fontSize: 14,
                          color: "black"
                        } }>${ item?.price }</p>
                      </div>
                    </div>
                    <div style={ {
                      display: "flex",
                      justifyContent: "end",
                      gap: 10,
                      marginTop: 10
                    } }>

                      {
                        !!isLoggedIn && `${item.userId}` !== userId && `${ item.favorite?.userId }` !== userId && <HeartOutlined
                        onClick={()=>saveProperty(item?.id)}
                        style={ {
                          padding: 8,
                          background: "#EEF5FF",
                          fontSize: 20,
                          borderRadius: 20,
                          color: "#1677ff"
                        } }/>
                      }

                      {
                        !!isLoggedIn && `${item.userId}` !== userId && `${ item.favorite?.userId }` === userId && <HeartFilled
                        onClick={()=>removeSaveProperty(item?.id)}
                        style={ {
                          padding: 8,
                          background: "#EEF5FF",
                          fontSize: 20,
                          borderRadius: 20,
                          color: "#1677ff"
                        } }/>
                      }

                      { !!isLoggedIn && <MailOutlined title={ "Message" } onClick={ async () => {
                        await createConversation(item?.userId)
                        navigate("/conversation")
                      } }
                                      style={ {
                                        padding: 8,
                                        background: "#EEF5FF",
                                        fontSize: 20,
                                        borderRadius: 20,
                                        color: "#1677ff"
                                      } }/> }
                      <SendOutlined title={"Visit"} onClick={ () => navigate(`/details/${ item?.id }`) }
                                    style={ {
                                      padding: 8,
                                      background: "#EEF5FF",
                                      fontSize: 20,
                                      borderRadius: 20,
                                      color: "#1677ff"
                                    } }/>
                    </div>
                  </div>
                </Popup>
              </Marker>
              )
          }
          <MapMover position={ state.centerMap }/>

        </MapContainer>

        <div className={ "main-featured" } style={ {
          background: "none",
          marginTop: 30
        } }>
          <h3>Filter Results for <strong>"{ state.currCity }"</strong></h3>
          <div style={ {
            marginTop: 30
          } }>
            { state.loader ? <Loader/> :
              <ContainerCard data={ filteredData } getProperties={ () => filter(state.searchedData) }/> }
          </div>
        </div>
      </div>
    </div>
  </div>
}

export default SearchScreen
